module.exports = __webpack_public_path__ + "img/11_93.2e042863.png";